import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './service.css'; // Import the CSS file for styling

const ServiceMaintenance = () => {
  const images = [
   "/images/Service and Maintenance/Maintenance_01.jpg",
"/images/Service and Maintenance/Maintenance_02.jpg",
"/images/Service and Maintenance/Maintenance_03.jpg",
"/images/Service and Maintenance/Maintenance_04.jpg",
"/images/Service and Maintenance/Maintenance_05.jpg",
"/images/Service and Maintenance/Maintenance_06.jpg",
"/images/Service and Maintenance/Maintenance_07.jpg",
"/images/Service and Maintenance/Maintenance_08.jpg",
"/images/Service and Maintenance/Maintenance_09.jpg",
"/images/Service and Maintenance/Maintenance_10.jpg",
"/images/Service and Maintenance/Maintenance_11.jpg",
"/images/Service and Maintenance/Maintenance_12.jpg",

  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Function to go to the next image
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Function to go to the previous image
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Auto change image every 6 seconds
  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []);

  return (
    <div className="servicemaintenance-container">
      <Link to="/" className="home-button">Home</Link> {/* Home button */}
      
      <div className="image-frame">
        <div className="text-container">
          <h2> <div className="title-gc"> Service & Maintenance </div></h2>
          <p> <div className="text-blurb">
            Traditional Line provides ongoing service and maintenance to our clients, including seasonal cleaning, architectural repairs, fire and flood restoration, HVAC servicing and preventive maintenance, and all manner of projects large and small.
          </div> </p>
        </div>

        <div className="slideshow-container">
          <img
            src={images[currentImageIndex]}
            alt={`Service Maintenance Slide ${currentImageIndex}`}
            className="servicemaintenance-image"
          />
          {/* Navigation buttons */}
          <button className="prev-button" onClick={prevImage}>❮</button>
          <button className="next-button" onClick={nextImage}>❯</button>
        </div>
      </div>
    </div>
  );
};

export default ServiceMaintenance;
